import actions from './actions'
import mutations from './mutations'
import defaultState from './defaultState'
import getters from './getters'

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: defaultState(),
}
